import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedHeartOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.24 2.807c.65-.941 1.433-1.1 1.964-.964.547.14.996.62.996 1.372 0 .554-.396 1.202-1.268 1.952-.71.61-1.587 1.163-2.432 1.68-.845-.517-1.722-1.07-2.432-1.68-.872-.75-1.268-1.398-1.268-1.952 0-.75.449-1.231.996-1.371.531-.136 1.314.022 1.963.963l.741 1.072zm4.76.408C24 1.632 22.985.441 21.65.1c-1.053-.27-2.208.005-3.15.841-.943-.836-2.097-1.11-3.15-.84C14.014.442 13 1.633 13 3.215c0 1.39.946 2.501 1.895 3.317 1.1.946 2.37 1.67 3.605 2.422 1.236-.753 2.504-1.476 3.605-2.422C23.055 5.716 24 4.605 24 3.215M11 1C3.5 1 1 6 1 11s2.5 10 10 10c2.96 0 5.142-.779 6.698-2.03l4.026 4.027 1.272-1.273-4.034-4.034C20.413 15.84 21 13.424 21 11.008h-1.8c-.001 2.23-.563 4.266-1.77 5.715C16.27 18.116 14.317 19.2 11 19.2s-5.27-1.084-6.43-2.477C3.362 15.273 2.8 13.233 2.8 11s.562-4.272 1.77-5.722C5.73 3.885 7.683 2.8 11 2.8z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierOutlinedHeartOutlinedSize24Glyph.displayName = 'MagnifierOutlinedHeartOutlinedSize24Glyph';
